export default __webpack_public_path__ + "static/media/Cecilia-profile-pic.e742fc4a.svg";